import BounceLoader from "react-spinners/BounceLoader"
import { theme } from "../../styles/stitches.config"

const Loader = () => {
  return <BounceLoader color={theme.colors.secondary.value} />
}

export default Loader
